import { Component } from '@angular/core';
import { TextModes } from '../../../../../components/ui/controls/text-input/text-input.component';

@Component({
  selector: 'app-style-form-controls',
  templateUrl: './style-form-controls.component.html',
  standalone: false,
})
export class StyleFormControlsComponent {
  InputTextModesEnum = TextModes;
}
